import { CloseOutlined } from "@ant-design/icons";

// A filter with nothing to choose: picking it from "Add filter" applies it
// (see `flag` in dropdown-filters), so its chip is just the name and a remove
// button. Styled like the other filter chips.
const FlagFilter = ({ field, onRemove }) => (
  <div
    data-testid={`filters-chip-${field.id}`}
    style={{
      display: "inline-flex",
      alignItems: "center",
      background: "#FFFFFF",
      border: "1px solid #6C6C8929",
      borderRadius: 8,
      padding: "5px 10px",
      fontSize: 14,
      maxWidth: "100%",
    }}
  >
    <span style={{ fontWeight: 600 }}>{field.name}</span>

    <div
      style={{
        width: 1,
        height: 16,
        background: "#6C6C89",
        opacity: 0.3,
        borderRadius: 1,
        marginLeft: 8,
        marginRight: 8,
        flexShrink: 0,
      }}
    />

    <span
      aria-label={`Remove ${field.name} filter`}
      style={{
        cursor: "pointer",
        color: "rgba(178, 178, 199, 1)",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
      onClick={(e) => {
        e.stopPropagation();
        onRemove();
      }}
      role="button"
    >
      <CloseOutlined style={{ fontSize: 12 }} />
    </span>
  </div>
);

export default FlagFilter;
